import type { LaunchNetworkConfig } from "@models/launchNetwork.model";

export class LaunchNetworkConfigSerializer {
  deserialize(data: any): LaunchNetworkConfig {
    return {
      id: data.id,
      network: data.network,
      is_enabled: data.is_enabled ?? false,
      network_template_id: data.network_template_id ?? null,
      launch_id: data.launch ?? null,
      network_resource_id: data.network_resource_id ?? null,
      network_sub_resource_id: data.network_sub_resource_id ?? null
    };
  }

  deserializeList(data: any[]): LaunchNetworkConfig[] {
    return data.map((item) => this.deserialize(item));
  }
}